import { Chip } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

interface ChipSpec { color: 'success' | 'warning' | 'info' | 'default', label: string, icon?: JSX.Element }

// A complete building reads "Submitted" (green) whether or not its report was submitted —
// report submission is a lock, not a status. Edited is a provenance marker; Pending is
// "In progress"; a building with no form is "Not started".
const STATUS_CHIP: Record<string, ChipSpec> = {
  Submitted: { color: 'success', label: 'Submitted', icon: <CheckCircleIcon /> },
  Edited: { color: 'info', label: 'Edited', icon: <EditOutlinedIcon /> },
  Pending: { color: 'warning', label: 'In progress', icon: <FiberManualRecordIcon /> },
  NotStarted: { color: 'default', label: 'Not started' }
}

export const StatusChip = ({ status }: { status: string }): JSX.Element => {
  const spec = STATUS_CHIP[status] ?? { color: 'default' as const, label: status }
  return <Chip size='small' icon={spec.icon} label={spec.label} color={spec.color} variant='outlined' data-testid='p2pStatusChip' />
}
